import { createAsyncThunk, createSlice, PayloadAction} from "@reduxjs/toolkit";
import { RootState } from "../../../app/store";
import fetchAPI from "../../../common/fetchAPI";
import { breakStateClass } from './interfaces/breakStateClass'
import { sortData } from "../../../common/timeLiveFunction";
const initialState: breakStateClass = {
    isLoading: false,
    breakList: [],
    status: "idle",
    selectedRecord: {},
    isReload: false,
    sortOrder: 'asc',
    sortColumn: 'BreakType',
    search: '',
    pageNo: 1,
    pageSize: 10
};
interface IThunkApi{
    state: {
        break: breakStateClass
    },
}
export const getAccountbreakAsync = createAsyncThunk
     <any, void, IThunkApi>
    (
        'break/getAccountbreakAsync',
      async( arg, thunkApi) =>{       
            const response = await fetchAPI('api/V2/BreakType', 'Get', '',true, '02c8675f-648f-4c76-8fcc-73d02e69df21');
            const json = await response.json();
            return json; 
        }
    )
    export const getAccountbreakByAccountbreakIdAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'break/getAccountbreakByAccountbreakId',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/BreakType/' + arg, 'Get', '', true, '02c8675f-648f-4c76-8fcc-73d02e69df21');
            const json = await response.json();
            return json;
        }
    )    


    export const addAccountbreakAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'break/addAccountbreak',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/BreakType/', 'POST', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )    

    
export const updateAccountbreakAsync = createAsyncThunk
<any, any, IThunkApi>
(
    'break/updateAccountbreak',
    async (arg, thunkApi) => {
        const { AccountBreakTypeId, ...argWithoutId } = arg;
        const response = await fetchAPI('api/V2/BreakType/' + AccountBreakTypeId, 'PUT', argWithoutId, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
        const json = await response.json();
        return json;
    }
)


export const deleteAccountbreakAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'break/deleteAccountBreak',
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/BreakType/' + arg, 'DELETE', '', true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
        }
    )

    export const deleteSelectedAccountbreaksAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        "break/deleteSelectedAccountbreak",
        async (arg, thunkApi) => {
            const response = await fetchAPI('api/V2/BreakType/DeleteAllSelectedRecordBreak', 'Delete', arg, true, '0df3ab0c-4033-4013-8b1e-2f0b64f8cbab');
            const json = await response.json();
            return json;
 
        }
    )
    export const breakSlice = createSlice({
        name: 'break',
        initialState,
        reducers: {
            resetSelectedRecordObjectInState: (state) => {
                state.selectedRecord = {};
            },
            checkedState: (state, action) => {
                const currentindex = state.breakList.findIndex((item) => item.AccountBreakTypeId == action.payload);
                const newArray = [...state.breakList];
                newArray[currentindex] = { ...newArray[currentindex], isSelected: 1 };
                state.breakList = newArray;
            },
            unCheckedState: (state, action) => {
                const currentindex = state.breakList.findIndex((item) => item.AccountBreakTypeId == action.payload);
                const newArray = [...state.breakList];
                newArray[currentindex] = { ...newArray[currentindex], isSelected: 0 };
                state.breakList = newArray;
            },
            checkedAllState: (state) => {
                const newArray = state.breakList.map((item) => ({
                    ...item,
                    isSelected: 1,
                }));
                state.breakList = newArray;
            },
            unCheckedAllState: (state) => {
                const newArray = state.breakList.map((item) => ({
                    ...item,
                    isSelected: 0,
                }));
                state.breakList = newArray;
            },
              checkAllCheckboxIsUncheckedState: (state) => {
              },
              updatePagination: (state, action: PayloadAction<any>) => {
                state.pageSize = action.payload.pageSize;
                state.pageNo = action.payload.pageNo;
                state.search = action.payload.search;
            },
            updateSorting: (state, action) => {
                state.sortOrder = action.payload.sortOrder;
                state.sortColumn = action.payload.sortColumn;
                state.pageSize = action.payload.pageSize;
                state.pageNo = action.payload.pageNo;
                let tempArray = state.breakList;
                state.breakList = sortData(tempArray, action.payload.sortOrder, action.payload.sortColumn);
            }

            },
    
        extraReducers: (builder) => {
            builder
                .addCase(getAccountbreakAsync.pending, (state) => {
                    state.status = 'loading';
                    state.isLoading = true;
                })
                .addCase(getAccountbreakAsync.fulfilled, (state, { payload }) => {                
                    state.status = 'idle';
                    if (Object.keys(payload.Data).length === 0) {
                        state.breakList = [];
                    } else {
                        state.breakList = payload.Data;
                        state.breakList.map((item: any) => {
                            item.isSelected = 0
                        });
                    }
                    state.isReload = false;
                    state.isLoading = false;
                    state.selectedRecord = {};                    
                })
                .addCase(getAccountbreakAsync.rejected, (state) => {
                    state.status = 'failed';
                    state.isLoading = false;

                })       
                .addCase(getAccountbreakByAccountbreakIdAsync.pending, (state) => {
                    state.status = 'loading';
                    state.isLoading = true;

                })
                .addCase(getAccountbreakByAccountbreakIdAsync.fulfilled, (state, { payload }) => {
                    state.status = 'idle';
                    state.selectedRecord = payload.Data[0];
                    state.isLoading = false;

                })
                .addCase(getAccountbreakByAccountbreakIdAsync.rejected, (state) => {
                    state.status = 'failed';
                    state.isLoading = false;

                })
                .addCase(addAccountbreakAsync.pending,(state)=>{ 
                    state.status= 'loading';
                    state.isLoading = true;
                })
                .addCase(addAccountbreakAsync.fulfilled, (state, {payload})=>{
                    state.status = 'idle';
                    state.isReload = true;
                    state.isLoading = false;

                })
                .addCase(addAccountbreakAsync.rejected, (state)=>{
                    state.status= 'failed';
                    state.isLoading = false;

                })            
                .addCase(updateAccountbreakAsync.pending,(state)=>{
                    state.status= 'loading';
                    state.isLoading = true;
                })            
                .addCase(updateAccountbreakAsync.fulfilled, (state, {payload})=>{
                    console.log("frm redux")
                    state.status = 'idle';
                    state.isReload =true;
                    state.isLoading = false;
                })
                .addCase(updateAccountbreakAsync.rejected, (state)=>{
                    state.status = 'failed';
                    state.isLoading = false;

                })
                .addCase(deleteAccountbreakAsync.pending, (state)=>{
                    state.status = 'loading';
                    state.isLoading= true;
                })
                .addCase(deleteAccountbreakAsync.fulfilled ,(state, {payload})=>{
    
                    state.status = 'loading';
                    state.isReload = true;
                    state.isLoading = false;
                })            
                .addCase(deleteAccountbreakAsync.rejected, (state) => {
                    state.status = 'failed';
                    state.isLoading = false;

                })
                .addCase(deleteSelectedAccountbreaksAsync.pending, (state) => {
                    state.status = 'loading';
                    state.isLoading = true;

                })
                .addCase(deleteSelectedAccountbreaksAsync.fulfilled, (state, { payload }) => {
                    state.status = 'idle';
                    state.isReload = true;
                    state.isLoading = false;

                })
                .addCase(deleteSelectedAccountbreaksAsync.rejected, (state) => {
                    state.status = 'failed';
                    state.isLoading = false;

                })
        } 
    });
    




    export const { resetSelectedRecordObjectInState, checkedState, unCheckedState, checkedAllState, unCheckedAllState,checkAllCheckboxIsUncheckedState,updatePagination,updateSorting} = breakSlice.actions
    export const departmentState = (state: RootState) => state.departments
    export default breakSlice.reducer
